import styled from 'styled-components';
import Color from '@/utils/color';
import { DragEventHandler } from 'react';

export type DraggableContainerProps = {
  children: React.ReactNode;
  id: string;
  onDragStart?: DragEventHandler<HTMLDivElement>;
  onDragOver?: DragEventHandler<HTMLDivElement>;
  onDrop?: DragEventHandler<HTMLDivElement>;
  draggable?: boolean;
};

export const DraggableContainer = styled.div<DraggableContainerProps>`
  padding: 0.5rem;
  margin: 0.5rem 0;
  border: 2px solid #ddd;
  cursor: move;
  cursor: grab;
`;

export const DotContainer = styled.span`
  color: ${Color.DarkGrey};
`;
